import config from './config'

export const FORM_CONFIG = `
${config}
`
export const FORM_ADVANCED = ``
